module.exports = __webpack_public_path__ + "static/media/waste & water.d7514233.jpg";